<template>
  <v-col class="chart-pane pr-10">
    <v-card-subtitle>Display Options</v-card-subtitle>
    <v-card-text>
      <v-switch v-model="showDots" label="Show Dots" color="primary" />
    </v-card-text>
    <v-card-subtitle>Scaling Options</v-card-subtitle>
    <v-card-text>
      <v-switch
        v-model="autoscaling"
        label="Automatic Scaling"
        color="primary"
        hide-details
      />
      <v-text-field
        v-if="!autoscaling"
        v-model.number="minY"
        label="Min.Y"
        type="number"
        inputmode="numeric"
        variant="underlined"
        :error-messages="errorMsgMin"
      />
      <v-text-field
        v-if="!autoscaling"
        v-model.number="maxY"
        label="Max.Y"
        type="number"
        inputmode="numeric"
        variant="underlined"
        :error-messages="errorMsgMax"
      />
    </v-card-text>
  </v-col>
</template>

<script setup lang="ts">
import { ref, watch, onUpdated } from "vue";

const props = defineProps<{
  showDots: boolean;
  autoscaling: boolean;
  minY: number;
  maxY: number;
}>();

const emit = defineEmits(["changeShowDots", "changeScaling", "chartUpdate"]);

const showDots = ref<boolean>(props.showDots);
const autoscaling = ref<boolean>(props.autoscaling);
const minY = ref<number | "">(props.minY);
const maxY = ref<number | "">(props.maxY);
const errorMsgMin = ref("");
const errorMsgMax = ref("");

watch(showDots, (newVal: boolean) => {
  emit("changeShowDots", newVal);
});

watch(autoscaling, (newVal: boolean) => {
  emit("changeScaling", newVal, minY.value, maxY.value);
});

watch(minY, (newVal: number | "") => {
  if (newVal === "" || maxY.value === "") {
    errorMsgMin.value = "Please enter value";
  } else if (newVal >= maxY.value) {
    errorMsgMin.value = "Must be MinY < MaxY";
  } else {
    emit("changeScaling", false, newVal, maxY.value);
    errorMsgMin.value = "";
  }
});

watch(maxY, (newVal: number | "") => {
  if (newVal === "" || minY.value === "") {
    errorMsgMax.value = "Please enter value";
  } else if (minY.value >= newVal) {
    errorMsgMax.value = "Must be MinY < MaxY";
  } else {
    emit("changeScaling", false, minY.value, newVal);
    errorMsgMax.value = "";
  }
});

onUpdated(() => {
  showDots.value = props.showDots;
  autoscaling.value = props.autoscaling;
  minY.value = props.minY;
  maxY.value = props.maxY;
});
</script>
